var Backbone, SupportCommonBaseView,
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

Backbone = require('backbone');

Backbone.$ = $;

SupportCommonBaseView = (function(superClass) {
  extend(SupportCommonBaseView, superClass);

  function SupportCommonBaseView() {
    return SupportCommonBaseView.__super__.constructor.apply(this, arguments);
  }

  SupportCommonBaseView.prototype.render = function() {
    return this.$el.append(toHtml(this.template, this.toHash(), this.I18nScope));
  };

  SupportCommonBaseView.prototype.toHash = function() {
    var ref;
    return ((ref = this.model) != null ? ref.toJSON() : void 0) || {};
  };

  return SupportCommonBaseView;

})(Backbone.View);

module.exports = SupportCommonBaseView;

//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiL3Zhci9ncm91cG9uL2hvbWUvcm11cnVnYW4vbmFwaXN0cmFuby9idWlsZC8xNTAxNzgyMDE2MzA2LTU5NDM1L3Byb2R1Y3Rpb24tMjAxNy4wOC4wM18xNy4zNi9zdXBwb3J0X2FwcC9tb2R1bGVzL3N1cHBvcnQvZnJvbnRlbmQvdmlld3MvY29tbW9uL3ZpZXdzL2NvbW1vbl9iYXNlX3ZpZXcuY29mZmVlIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiL3Zhci9ncm91cG9uL2hvbWUvcm11cnVnYW4vbmFwaXN0cmFuby9idWlsZC8xNTAxNzgyMDE2MzA2LTU5NDM1L3Byb2R1Y3Rpb24tMjAxNy4wOC4wM18xNy4zNi9zdXBwb3J0X2FwcC9tb2R1bGVzL3N1cHBvcnQvZnJvbnRlbmQvdmlld3MvY29tbW9uL3ZpZXdzL2NvbW1vbl9iYXNlX3ZpZXcuY29mZmVlIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBLElBQUEsK0JBQUE7RUFBQTs7O0FBQUEsUUFBQSxHQUFXLE9BQUEsQ0FBUSxVQUFSOztBQUNYLFFBQVEsQ0FBQyxDQUFULEdBQWE7O0FBRVA7Ozs7Ozs7a0NBRUosTUFBQSxHQUFRLFNBQUE7V0FDTixJQUFDLENBQUEsR0FBRyxDQUFDLE1BQUwsQ0FBWSxNQUFBLENBQU8sSUFBQyxDQUFBLFFBQVIsRUFBa0IsSUFBQyxDQUFBLE1BQUQsQ0FBQSxDQUFsQixFQUE2QixJQUFDLENBQUEsU0FBOUIsQ0FBWjtFQURNOztrQ0FHUixNQUFBLEdBQU8sU0FBQTtBQUNMLFFBQUE7NENBQU0sQ0FBRSxNQUFSLENBQUEsV0FBQSxJQUFvQjtFQURmOzs7O0dBTDJCLFFBQVEsQ0FBQzs7QUFRN0MsTUFBTSxDQUFDLE9BQVAsR0FBaUIifQ==
